;(function ($) {

  var cardsList = $('#blog_masonry');

  $(document).ready(function () {

    $('body').on('change', '#select_blog_category', blog_filter_change);

  });

  $(window).load(function () {
    init_blog_masonry();
  });

  /**
   * Reload the Page when someone selects a category from the dropdown
   */
  function blog_filter_change() {
    var $this = $(this),
      url = $this.val();

    if (url.length) {
      window.location = url;
    }
  }

  /**
   * Initialize the Blog Masonry Layout
   */
  function init_blog_masonry() {

    if (cardsList.length) {
      cardsList.imagesLoaded(function () {
        cardsList.masonry({
          itemSelector: '.masonry-grid-item',
          columnWidth: '.masonry-grid-sizer',
          gutter: '.masonry-gutter-sizer',
          percentPosition: true,
          isResizeBound: true,
          hiddenStyle: {
            opacity: 0,
            transform: 'scale(0.001)'
          }
        });

      });

    }
  }

})(jQuery);